<!-- Severity Bars Icon - 4 vertical bars with different heights -->
<div class="severity-bars" [ngClass]="severity">
  <div class="bar bar-1"></div>
  <div class="bar bar-2"></div>
  <div class="bar bar-3"></div>
  <div class="bar bar-4"></div>
</div>
